<script setup>
import {computed, onMounted} from 'vue'
import {useStore} from 'vuex'
import {useRouter, useRoute} from 'vue-router'

const store = useStore()
const router = useRouter()
const route = useRoute()

const selectedOrgId = computed(() => store.getters['org/getSelected'])
const orgs = computed(() => store.getters['org/getOrgs'])

onMounted(async () => {
  // Skip redirect if we're already on an organization route
  if (route.name === 'OrgProjects' || route.name === 'OrgLayers') {
    return
  }

  // Wait for organizations to be loaded
  if (!orgs.value.length) {
    await store.dispatch('org/fetchOrgs')
  }

  // If we have a selected org, redirect to its projects page
  if (selectedOrgId.value) {
    router.replace({ name: 'OrgProjects', params: { org_id: selectedOrgId.value } })
  } else if (orgs.value.length > 0) {
    // If no org is selected but we have orgs, select the first one and redirect
    const firstOrg = orgs.value[0]
    await store.dispatch('org/setSelectedOrg', firstOrg.organization_id.toString())
    router.replace({ name: 'OrgProjects', params: { org_id: firstOrg.organization_id } })
  }
})
</script>

<template>
  <div class="flex items-center justify-center h-full">
    <div class="text-center">
      <h3 class="text-lg font-semibold">Loading...</h3>
      <p class="text-gray-500 mt-2">Redirecting to your organization</p>
    </div>
  </div>
</template>
